import { useQuery } from "@tanstack/react-query";
import { fetchSiteSettings } from "@/lib/api";

export const SITE_SETTINGS_KEY = ["site-settings"];

export const useSiteSettings = (options = {}) => {
    return useQuery({
        queryKey: SITE_SETTINGS_KEY,
        queryFn: fetchSiteSettings,
        ...options,
    });
};
